(function () {
  Flint.file('mframework/views/uploadPicChooser.js', function (require) {
    Flint.staticStyles('UploadPicChooser', {
      '$actionRow': '#_flintapp actionRow.UploadPicChooser, #_flintapp .UploadPicChooser.actionRow, #_flintapp .ViewUploadPicChooser.actionRow, #_flintapp .UploadPicChooser > .actionRow',
      '$uploader': '#_flintapp uploader.UploadPicChooser, #_flintapp .UploadPicChooser.uploader, #_flintapp .ViewUploadPicChooser.uploader, #_flintapp .UploadPicChooser > .uploader'
    }, {
      '$actionRow': {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-around'
      },
      '$uploader': {
        flexGrow: 1
      }
    });
    Flint.view('UploadPicChooser', function (view, on, $) {
      var pro = initPro(view, {
        initialPicKey: M.defaultAtom(null),
        editable: M.defaultAtom(true),
        width: M.defaultAtom(300),
        height: M.defaultAtom(168),
        circle: M.defaultAtom(false),
        children: atom(),
        picStyle: M.mapAtom({}),
        noPicStyle: M.mapAtom({}),
        zoomable: M.defaultAtom(false)
      });

      var picKey = atom(pro.initialPicKey.get());
      var uploading = atom(false);

      picKey.react(function (picKey) {
        if (view.props.onSelect) {
          view.props.onSelect({ picKey: picKey });
        }
        M.mixpanel.track("UploadPicChooserSelect", { picKey: picKey });
      }, { skipFirst: true });

      var noPicStyle = derivation(function () {
        return IMap({
          width: pro.width.get(),
          height: pro.height.get(),
          alignItems: 'center',
          justifyContent: 'center',
          background: 'white',
          border: '1px dashed #ccc',
          borderRadius: pro.circle.get() ? '50%' : 8
        }).merge(pro.noPicStyle.get());
      });view.render(function () {
        return view.el(
          ['picSection', 1],
          null,
          Flint.iff(picKey.get() && !uploading.get()) && view.el(['Pic', 1], { if: picKey.get() && !uploading.get(),
            picKey: picKey.get(),
            faces: true,
            zoomable: pro.zoomable.get(),
            onZoomIn: view.props.onZoomIn,
            onZoomOut: view.props.onZoomOut,
            style: IMap({
              width: pro.width.get(),
              height: pro.height.get(),
              borderRadius: pro.circle.get() ? '50%' : null
            }).merge(pro.picStyle.get()).toJS()
          }),
          Flint.iff(pro.editable.get() && !picKey.get() && !uploading.get()) && view.el(
            ['S3Uploader', 1],
            { if: pro.editable.get() && !picKey.get() && !uploading.get(),
              accept: 'image/*',
              onStartUpload: function () {
                return uploading.set(true);
              },
              onUploaded: function (e) {
                uploading.set(false);
                picKey.set(e.s3Key);
              }
            },
            view.el(
              ['noPic', 1],
              { style: noPicStyle.get().toJS() },
              pro.children.get()
            )
          ),
          Flint.iff(!pro.editable.get() && !picKey.get() && !uploading.get()) && view.el(['noPic', 2], { if: !pro.editable.get() && !picKey.get() && !uploading.get(),
            style: noPicStyle.get().toJS()
          }),
          Flint.iff(uploading.get()) && view.el(
            ['noPic', 3],
            { if: uploading.get(), style: noPicStyle.get().toJS() },
            view.el(['Loader', 1], null)
          )
        );
      });view.render(function () {
        return Flint.iff(picKey.get() && pro.editable.get()) && view.el(
          ['actionRow', 1],
          { if: picKey.get() && pro.editable.get() },
          view.el(
            ['S3Uploader', 2],
            {
              accept: 'image/*',
              onStartUpload: function () {
                return uploading.set(true);
              },
              onUploaded: function (e) {
                uploading.set(false);
                picKey.set(e.s3Key);
              }
            },
            view.el(['EditLink', 1], null)
          ),
          view.el(['DeleteButton', 1], { onClick: function () {
              return picKey.set(null);
            } })
        );
      });
    });
  })
})();
//# sourceMappingURL=uploadPicChooser.js.map
